<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Mantenimiento de empresas de seguros
      </h2>
      <MainInsuranceCompanies />
    </div>
  </template>
  
  <script>
  import MainInsuranceCompanies from "@/components/InsuranceCompanies/MainInsuranceCompanies.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "InsuranceCompanies",
    components: {
        MainInsuranceCompanies,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  